export const GET_VAT_NUMBERS_REQUEST = 'GET_VAT_NUMBERS_REQUEST';
export const GET_VAT_NUMBERS_SUCCESS = 'GET_VAT_NUMBERS_SUCCESS';
export const GET_VAT_NUMBERS_FAILURE = 'GET_VAT_NUMBERS_FAILURE';

export const REMOVE_VAT_NUMBERS = 'REMOVE_VAT_NUMBERS';

export const REMOVE_ALL_FILING_TYPES = 'REMOVE_ALL_FILING_TYPES';

export const SET_BANKING_DETAILS_START = 'SET_BANKING_DETAILS_START';
export const SET_BANKING_DETAILS_SUCCESS = 'SET_BANKING_DETAILS_SUCCESS';
export const SET_BANKING_DETAILS_FAILURE = 'SET_BANKING_DETAILS_FAILURE';

export const GET_BANKING_DETAILS_START = 'GET_BANKING_DETAILS_START';
export const GET_BANKING_DETAILS_SUCCESS = 'GET_BANKING_DETAILS_SUCCESS';
export const GET_BANKING_DETAILS_FAILURE = 'GET_BANKING_DETAILS_FAILURE';

export const CLEAR_BANKING_DETAILS = 'CLEAR_BANKING_DETAILS';
